import { Badge, Button, Group, Indicator, Menu, ThemeIcon, Tooltip } from "@mantine/core";
import { IconChevronDown, IconShare3, IconSwitchVertical, IconUser } from "@tabler/icons-react";
import { useEffect, useMemo, useState } from "react";
import { getOtherPrms } from "../../../../api/PRMAPI";
import { useNavigate, useParams } from "react-router-dom";
import { useLeadsStore } from "../../../../stores/LeadsStore";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useProfileStore } from "../../../../stores/UserStore";

const LeadsBaseSelector = () => {
  const lang = useLanguage((s) => s.language);
  const { userId } = useParams();
  const [loading, setLoading] = useState(true);
  const prms = useLeadsStore((s) => s.prms);
  const profile = useProfileStore((s) => s.profile);

  const navigate = useNavigate();
  const handlePrm = (id) => {
    navigate("/leads-tracking/" + id);
  };

  useEffect(() => {
    getOtherPrms().finally(() => setLoading(false));
  }, []);

  const actualPrmName = useMemo(() => {
    const x = userId
      ? prms?.find((x) => x.id === parseInt(userId))
      : prms.find((x) => x.id === profile?.id);

    return `${x?.first_name || "-"} ${x?.last_name || "-"}`;
  }, [prms, profile?.id, userId]);

  const newReplies = useMemo(() => {
    let new_reply = 0;
    let new_conversation = 0;
    prms.forEach(prm => {
      if ((userId ? prm.id !== parseInt(userId) : prm.id !== profile?.id)) {
        new_reply += prm?.new_reply || 0;
        new_conversation += prm?.new_first_reply || 0;
      }
    });

    return {
      all_new_reply: new_reply,
      new_reply: new_reply - new_conversation,
      new_conversation
    }
  }, [prms, userId, profile?.id])

  return (
    <>
      <Group>
        <Menu>
          <Menu.Target>
            <Tooltip label={
              newReplies.all_new_reply > 0 &&
              `${lang.prm.new_replies_tooltip.replace(
                "$",
                newReplies.new_reply
              ).replace(
                "#",
                newReplies.new_conversation ? lang.prm.new_conversation_tooltip.replace("$", newReplies.new_conversation) : ""
              )}`
            }
              disabled={newReplies.all_new_reply === 0}
              withArrow
            >
              <Indicator color="red" disabled={!newReplies.all_new_reply} offset={4} size={22} label={newReplies.all_new_reply} styles={{ indicator: { fontSize: 10 } }} >
                <Button
                  rightSection={<IconSwitchVertical size={20} />}
                  size="md"
                  variant="outline"
                  loading={loading}
                  radius={"md"}
                  fw={600}
                  fz={16}
                  px={12}
                  style={{
                    borderWidth: 2
                  }}
                >
                  {actualPrmName}
                  {/* <span style={{ fontSize: 12, opacity: .5, marginLeft: 8, fontWeight: 400 }}>#{userId || profile?.id}</span> */}
                </Button>
              </Indicator>
            </Tooltip>
          </Menu.Target>
          <Menu.Dropdown>
            {prms.sort((a, b) => a.id === profile.id ? -1 : b.id === profile.id ? 1 : 0).map((item) => (
              <Menu.Item
                key={item.id}
                onClick={() => handlePrm(item.id)}
                pos={"relative"}
                disabled={item.id === parseInt(userId)}
                fz={16}
                leftSection={
                  item.id !== profile.id ? (
                    <Tooltip label={lang.prm.from_sharing}>
                      <ThemeIcon
                        variant="subtle"
                        size={"md"}
                        color="gray"
                        px={0}
                      >
                        <IconShare3 size={24} />{" "}
                      </ThemeIcon>
                    </Tooltip>
                  ) : (
                    <Tooltip label={lang.prm.your_prm}>
                      <ThemeIcon
                        variant="subtle"
                        size={"md"}
                        color="gray"
                        px={0}
                      >
                        <IconUser size={24} />{" "}
                      </ThemeIcon>
                    </Tooltip>
                  )
                }
              >
                <Group>
                  {item.first_name} {item.last_name} #{item.id}

                  {
                    (userId ? item.id !== parseInt(userId) : item.id !== profile?.id) && item?.new_reply &&
                    <Badge right={0} color="red" size="sm">
                      {item.new_reply}
                    </Badge>
                  }
                </Group>
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        </Menu>
      </Group>
    </>
  );
};

export default LeadsBaseSelector;
